import { render, staticRenderFns } from "./RudkinCalmScore.vue?vue&type=template&id=5b96f600&scoped=true&"
import script from "./RudkinCalmScore.vue?vue&type=script&lang=js&"
export * from "./RudkinCalmScore.vue?vue&type=script&lang=js&"
import style0 from "./RudkinCalmScore.vue?vue&type=style&index=0&id=5b96f600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96f600",
  null
  
)

export default component.exports